import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import WolfpackLogo from '../Assets/Images/Homepage/wolfpackLogo.png'
import WolfpackImage from '../Assets/Images/Homepage/gif.png'
import BGLogo from '../Assets/Images/Homepage/BgLogo.png'
import RoundTextLogo from '../Components/RoundedTextLogo'
import IndustriesSection from '../Components/IndustriesSection'
import Services from '../Components/Services'
import OurWorks from '../Components/OurWorks'
import Carousel from '../Components/Carousle'
import Footer from '../Components/Footer/Footer'
import BigHeadingImage from '../Assets/Images/Homepage/bigHeadingImage.png'
import LetsTalk from '../Components/LetsTalk'
import AOS from "aos";
import "aos/dist/aos.css";
import MessageIcon from "../Assets/Images/MessageIcon.png";
import { NorthEast } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
// import headingvideo from '../Assets/video/headingvideo.mp4'
import thumbnailImage from '../Assets/Images/Homepage/videothumbnail.png'


const servicesData = [
  {
    title: "Brand Design & UI/UX",
    navigateurl: "brand-design-uiux",
    overviewLine: "Where strategy meets striking visuals and seamless user journeys to elevate perception, boost engagement, and drive lasting impact.",
    descriptions: [
      {
        title: "Growth Strategy",
        description: "Defining who your next best customers are and new market opportunities.",
      },
      {
        title: "Brand Identity",
        description: "The visual and behavioral base code for your brand across every interaction.",
      },
      {
        title: "Brand Foundation",
        description: "The core tenets of your brand (purpose, positioning, principles and measurement frameworks) to guide action.",
      },
      {
        title: "Brand AI Tools",
        description: "AI-enabled tools to help teams deliver brand systems cohesively and efficiently at scale.",
      },
      {
        title: "Brand Architecture",
        description: "How to organize your brand(s) and offerings to support growth ambitions.",
      },
      {
        title: "Brand System",
        description: "Defining how you flex and adapt your brand across interfaces.",
      },
    ],
    images: [
      {
        front: "/Images/Services/tandm-front.png",
        back: "/Images/Services/tandm-back.png",
        value: "tandm"
      },
      {
        front: "/Images/Services/skilljobs-front.png",
        back: "/Images/Services/skilljobs-back.png",
        value: "skilljobs"
      },
      {
        front: "/Images/Services/louca-front.png",
        back: "/Images/Services/louca-back.png",
        value: "louca"
      },
    ]
  },
  {
    title: "Website & Web Platform",
    navigateurl: "website-web-platform",
    overviewLine: "We design and develop scalable, high-performance websites and web applications that deliver seamless user experiences, strong functionality, and business-driven digital solutions.",
    descriptions: [
      {
        title: "Responsive Web Design",
        description: "Creating mobile-friendly and adaptive interfaces that provide a consistent experience across all devices.",
      },
      {
        title: "Custom Web Development",
        description: "Building tailored websites and web apps with modern frameworks to meet unique business needs.",
      },
      {
        title: "UI/UX Design",
        description: "Designing intuitive, user-centric interfaces that enhance engagement and usability.",
      },
      {
        title: "E-commerce Solutions",
        description: "Developing secure and scalable online stores with smooth checkout and payment integration.",
      },
      {
        title: "API Integration",
        description: "Connecting third-party services and backend systems for enhanced functionality and automation.",
      },
      {
        title: "Performance Optimization",
        description: "Improving speed, scalability, and overall performance for better user experience and SEO.",
      },
    ],
    images: [
      {
        front: "/Images/Services/futsaloz-front.png",
        back: "/Images/Services/futsaloz-back.png",
        value: "futsaloz"
      },
      {
        front: "/Images/Services/redarc-front.png",
        back: "/Images/Services/redarc-back.png",
        value: 'redarc'
      },
      {
        front: "/Images/Services/juicelabs-front.png",
        back: "/Images/Services/juicelabs-back.png",
        value: "juicelabs"
      },
    ]
  },
  {
    title: "Mobile App & IoT",
    navigateurl: "mobile-app-development-services",
    overviewLine: "We develop intelligent CRM systems and customer management software that streamline sales, improve customer relationships, and automate business workflows for better efficiency and growth.",
    descriptions: [
      {
        title: "Android & iOS App Development",
        description: "Creating high-performance native and cross-platform mobile apps with smooth user experiences.",
      },
      {
        title: "IoT Device Integration",
        description: "Connecting smart devices with applications for real-time data exchange and control.",
      },
      {
        title: "Custom Mobile Solutions",
        description: "Developing tailored mobile apps aligned with specific business goals and workflows.",
      },
      {
        title: "App Performance Optimization",
        description: "Enhancing speed, stability, and responsiveness for better user engagement.",
      },
    ],
    images: [
      {
        front: "/Images/Services/belong-front.png",
        back: "/Images/Services/belong-back.png",
        value: "belong"
      },
      {
        front: "/Images/Services/tandm-front.png",
        back: "/Images/Services/tandm-back.png",
        value: "tandm"
      },
      {
        front: "/Images/Services/pinch-front.png",
        back: "/Images/Services/pinch-back.png",
        value: "pinch"
      },
    ]
  },
  {
    title: "CRM & Custom Software",
    navigateurl: "custom-software-development-services",
    overviewLine: "We develop intelligent CRM systems and customer management software that streamline sales, improve customer relationships, and automate business workflows for better efficiency and growth.",
    descriptions: [
      {
        title: "Custom CRM Development",
        description: "Building tailored CRM platforms to manage leads, customers, and sales pipelines effectively.",
      },
      {
        title: "Customer Data Management",
        description: "Organizing and centralizing customer information for better insights and decision-making.",
      },
      {
        title: "Sales & Lead Automation",
        description: "Automating lead tracking, follow-ups, and sales processes to improve conversions.",
      },
      {
        title: "Workflow Automation",
        description: "Streamlining business operations by automating repetitive customer-related tasks.",
      },
      {
        title: "Analytics & Reporting",
        description: "Providing real-time dashboards and reports to track performance and customer behavior.",
      },
      {
        title: "Third-party Integrations",
        description: "Connecting CRM systems with tools like email, payment gateways, and marketing platforms.",
      },
    ],
    images: [
      {
        front: "/Images/Services/wefroth-front.png",
        back: "/Images/Services/wefroth-back.png",
        value: "wefroth"
      },
      {
        front: "/Images/Services/mysterymanagement-front.png",
        back: "/Images/Services/mysterymanagement-back.png",
        value: "mysterymanagement"
      },
      {
        front: "/Images/Services/connexion-front.png",
        back: "/Images/Services/connexion-back.png",
        value: "connexion"
      },
    ]
  },
  {
    title: "AI & Machine Learning",
    navigateurl: "ai-automation-and-machine-learning-services",
    overviewLine: "We deliver AI & Machine Learning solutions that turn data into smart insights and automation, including stock analysis, conversational AI, report QA, and custom chatbots to help businesses work faster and smarter.",
    descriptions: [
      {
        title: "Predictive analytics",
        description: "Uncovering patterns in your data to forecast trends and support smarter business decisions.",
      },
      {
        title: "Conversational AI",
        description: "Building intelligent assistants and chatbots that resolve queries instantly and at scale.",
      },
      {
        title: "Stock & investment analysis",
        description: "Applying advanced ML models to market data for sharper, faster investment decisions.",
      },
      {
        title: "AI-powered quality assurance",
        description: "Automating report validation and compliance checks to ensure accuracy across operations.",
      },
      {
        title: "Custom model development",
        description: "Designing and training bespoke ML models tailored to your unique business problems.",
      },
      {
        title: "Process automation",
        description: "Eliminating repetitive manual tasks by embedding intelligent automation into your workflows.",
      },
    ],
    images: [
      {
        front: "/Images/Services/wolfpack-front.png",
        back: "/Images/Services/wolfpack-back.png",
        value: "wolfpack"
      },
      {
        front: "/Images/Services/mysterymanagement-front.png",
        back: "/Images/Services/mysterymanagement-back.png",
        value: "mysterymanagement"
      },
      {
        front: "/Images/Services/betodyssey-front.png",
        back: "/Images/Services/betodyssey-back.png",
        value: 'betodyssey'
      },
    ]

  },
  {
    title: "Cloud Computing & DevOps ",
    navigateurl: "cloud-computing-devops",
    overviewLine: "We provide scalable cloud solutions and DevOps services that ensure faster deployments, high availability, and secure, efficient infrastructure management for modern digital businesses.",
    descriptions: [
      {
        title: "Cloud Infrastructure Setup",
        description: "Designing and deploying secure, scalable cloud environments tailored to business needs.",
      },
      {
        title: "DevOps Automation",
        description: "Implementing CI/CD pipelines to streamline development, testing, and deployment processes.",
      },
      {
        title: "Cloud Migration Services",
        description: "Seamlessly migrating applications and data to cloud platforms with minimal downtime.",
      },
      {
        title: "Scalable Architecture Design",
        description: "Building flexible systems that scale efficiently with business growth and demand.",
      },
      {
        title: "Monitoring & Performance Optimization",
        description: "Ensuring system reliability through continuous monitoring and performance tuning.",
      },
      {
        title: "Security & Compliance Management",
        description: "Implementing best practices to protect data, applications, and cloud infrastructure.",
      },
    ],
    images: [
      {
        front: "/Images/Services/wolfpack-front.png",
        back: "/Images/Services/wolfpack-back.png",
        value: "wolfpack"
      },
      {
        front: "/Images/Services/mysterymanagement-front.png",
        back: "/Images/Services/mysterymanagement-back.png",
        value: "mysterymanagement"
      },
      {
        front: "/Images/Services/wefroth-front.png",
        back: "/Images/Services/wefroth-back.png",
        value: "wefroth"
      },
    ]
  },
  {
    title: "SEO & Search Marketing",
    navigateurl: "seo-services",
    overviewLine: "We improve your visibility in search with technical SEO, content and local search strategies that bring qualified traffic and leads to your business.",
    descriptions: [
      {
        title: "Technical SEO",
        description: "Improving speed, structure and crawlability so search engines can find and rank your pages.",
      },
      {
        title: "Content & On-Page SEO",
        description: "Building search-focused pages and content around the terms your customers use.",
      },
      {
        title: "Local SEO",
        description: "Strengthening your Google Business Profile and local presence across Melbourne and Australia.",
      },
      {
        title: "Analytics & Reporting",
        description: "Tracking rankings, traffic and leads with clear monthly reporting.",
      },
    ],
    images: [
      {
        front: "/Images/Services/mysterymanagement-front.png",
        back: "/Images/Services/mysterymanagement-back.png",
        value: "mysterymanagement"
      },
      {
        front: "/Images/Services/futsaloz-front.png",
        back: "/Images/Services/futsaloz-back.png",
        value: "futsaloz"
      },
      {
        front: "/Images/Services/redarc-front.png",
        back: "/Images/Services/redarc-back.png",
        value: "redarc"
      },
    ]
  },
  {
    title: "Social Media Marketing",
    navigateurl: "social-media-marketing-services",
    overviewLine: "We plan, create and manage social media marketing that builds your brand, engages your audience and drives enquiries.",
    descriptions: [
      {
        title: "Social Strategy & Content",
        description: "Creating on-brand content and a clear strategy for the platforms your audience uses.",
      },
      {
        title: "Community Management",
        description: "Responding to comments and messages and building relationships with your audience.",
      },
      {
        title: "Paid Social Advertising",
        description: "Running targeted campaigns on Meta and LinkedIn with creative testing and conversion tracking.",
      },
      {
        title: "Reporting & Optimisation",
        description: "Measuring reach, engagement and leads, and improving results every month.",
      },
    ],
    images: [
      {
        front: "/Images/Services/wefroth-front.png",
        back: "/Images/Services/wefroth-back.png",
        value: "wefroth"
      },
      {
        front: "/Images/Services/juicelabs-front.png",
        back: "/Images/Services/juicelabs-back.png",
        value: "juicelabs"
      },
      {
        front: "/Images/Services/louca-front.png",
        back: "/Images/Services/louca-back.png",
        value: "louca"
      },
    ]
  },
];


const blogsData = [
  {
    id: 1,
    title: "Future of Artificial Intelligence",
    description:
      "Explore how AI is transforming industries with automation, predictive analytics, and intelligent systems shaping the future of technology.",
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 2,
    title: "Modern Web Development Trends",
    description:
      "Discover the latest trends in web development including React, serverless architecture, performance optimization, and responsive UI design.",
    image:
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 3,
    title: "Startup Growth Strategies",
    description:
      "Learn proven strategies to scale your startup, improve customer retention, and build a sustainable business model in competitive markets.",
    image:
      "https://images.unsplash.com/photo-1556155092-8707de31f9c4?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 4,
    title: "UI/UX Design Principles",
    description:
      "Understand core UI/UX principles that improve user experience, accessibility, and engagement across digital platforms.",
    image:
      "https://images.unsplash.com/photo-1545235617-9465d2a55698?q=80&w=800&auto=format&fit=crop",
  },
  {
    id: 5,
    title: "Cloud Computing Essentials",
    description:
      "A beginner-friendly guide to cloud computing, covering infrastructure, deployment models, and cloud security best practices.",
    image:
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=800&auto=format&fit=crop",
  },
];

function HomePage() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [])

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // animation happens only once
    });
  }, []);

  useEffect(() => {
    if (isMobile) return; // stop animation logic on mobile

    const handleScroll = () => {
      if (window.scrollY > 50 && !isScrolled) {
        setIsScrolled(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isScrolled, isMobile]);

  const videoRef = useRef(null);

  // Scroll play (muted)

  // useEffect(() => {
  //   const video = videoRef.current;
  //   if (!video) return;

  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.isIntersecting && isScrolled) {
  //         setTimeout(() => {
  //           video.play().catch(() => { });
  //         }, 1200);
  //       } else {
  //         video.pause();
  //       }
  //     },
  //     {
  //       threshold: 0.5,
  //     }
  //   );

  //   observer.observe(video);

  //   return () => observer.disconnect();
  // }, [isScrolled]);


  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    let timeout;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          timeout = setTimeout(() => {
            video.play().catch(() => { });
          }, 2000);
        } else {
          clearTimeout(timeout);
          video.pause();
        }
      },
      {
        threshold: 0.1,
      }
    );

    observer.observe(video);

    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, []);

  // First interaction unlock
  // useEffect(() => {
  //   const unlock = () => {
  //     if (videoRef.current) {
  //       // videoRef.current.muted = false;
  //     }
  //     window.removeEventListener("pointerdown", unlock);
  //   };

  //   window.addEventListener("pointerdown", unlock);
  // }, []);

  const handleVideoClick = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };




  return (
    <Box mt={{ xs: 8, md: 4, lg: 5 }}>
      {/* <Typography gutterBottom className='fs-72 bold-text mt-4  mx-auto  text-color-main text-center' data-aos="zoom-in" fontWeight={900}> CREATIVE TEAM <br /> BUILT ON <br /> <span className='text-light-main'>TRUST</span> & <br /><span className='text-light-main'>RESULTS</span>.</Typography> */}
      <Typography
        component="h1"
        variant="h1"
        sx={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0
        }}
      >
        Custom Apps Digital Platforms Built for Business Growth
      </Typography>
      <Typography gutterBottom className='fs-72 bold-text mt-4  mx-auto  text-color-main text-center' data-aos="zoom-in" fontWeight={900}> Custom <span className='text-light-main'>Apps</span> & <br /> Digital <span className='text-light-main'>Platforms</span> <br /> Built for <br />Business <span className='text-light-main'>Growth</span></Typography>
      {/* <Typography className='fs-16 text-center mb-4 text-grey' data-aos="fade-up" >Turning ambitious ideas into powerful digital products that help businesses grow, adapt & lead with confidence</Typography> */}
      <Typography className='fs-16 text-center mb-4 text-grey w-75 text-center mx-auto' data-aos="fade-up" >Melbourne-based strategy and leadership, backed by an experienced development team. <br /> We design and build mobile apps, web platforms, custom software and AI-powered solutions.</Typography>

      <Box className='w-100 mt-5 d-flex'>
        <Box
          component="video"
          ref={videoRef}
          muted
          loop
          playsInline
          poster={thumbnailImage}
          onClick={handleVideoClick}
          className='mx-auto bg-dark-main'
          sx={{
            width: isMobile ? "100%" : isScrolled ? "100%" : "50%",
            height: isMobile ? "auto" : isScrolled ? "calc(100vh - 80px)" : "50vh",
            borderRadius: isMobile ? "0px" : isScrolled ? "0px" : "200px",
            transition: isMobile ? "none" : "all 1s ease-in-out",
            margin: isMobile ? "none" : "auto",
            background: 'transparent !important',
            objectFit: isScrolled ? "contain" : "cover",
            // boxShadow:'0px 0px 5px black'
          }}
        >
          <source src={"/video/headingvideo.mp4"} type="video/mp4" />
          Your browser does not support the video tag.
        </Box>
      </Box>
      {/* <Box className='w-100 mt-5 d-flex'>
        <Box className='mx-auto bg-dark-main'
          component={'img'}
          width={isMobile ? "100%" : "50%"}
          src={BigHeadingImage}
          sx={{
            width: isMobile ? "100%" : isScrolled ? "100%" : "50%",
            height: isMobile ? "auto" : isScrolled ? "auto" : "50vh",
            borderRadius: isMobile ? "0px" : isScrolled ? "0px" : "200px",
            transition: isMobile ? "none" : "all 1s ease-in-out",
            margin: isMobile ? "none" : "auto !important"
          }}
        >

        </Box>
      </Box> */}

      <Box mt={{ xs: 3, md: 4, lg: 5 }}>
        <Typography className='fs-52 text-color-main' data-aos="fade-up" fontWeight={500}>What We Do</Typography>
        <Typography className='fs-16 text-grey' data-aos="fade-up" width={{ xs: "100%", md: "75%", lg: '50%' }}>We align human intelligence, advanced technology, and data-driven insight to design and deliver connected digital systems that create meaningful, consistent value across every interaction and channel.</Typography>
      </Box>
      <Box className='mt-2'>
        <Services services={servicesData} isNavigate={true} />
      </Box>

      {/* <Grid container spacing={1} alignItems={'end'}>
        {[...Array(6)].map((_, index) => {
          const isHovered = hoveredIndex === index;

          return (
            <Grid
              key={index}
              size={
                hoveredIndex === null
                  ? 2
                  : isHovered
                    ? 7
                    : Math.round((12 - 7) / 5)
              }
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              sx={{
                transition: "all 1.8s ease-in-out",
              }}
            >
              <Box className="p-3 bg-main" overflow={'hidden'}>
                <Box
                  component="img"
                  src={WolfpackLogo}
                  sx={{
                    // maxHeight:"80px",
                    width:'200px',
                    
                  }}
                />
              </Box>

              <Box>
                <Box
                  component="img"
                  src={isHovered ? `https://bs-uploads.toptal.io/blackfish-uploads/uploaded_file/file/53369/image-1568763265231-74e7c5e8b8b8efa17e1ba52b5107e140.gif` : WolfpackImage}
                  // className='w-100'
                  sx={{
                    height: "400px",
                    width:'100%',
                    objectFit:"cover"
                  }}
                />
              </Box>
            </Grid>
          );
        })}
      </Grid> */}
      <Box className='mt-5 p-3 border-10' bgcolor={'hsl(187, 100%, 12%)'} position={'relative'}>
        <Box component={'img'} src={BGLogo} height={'100%'} position={'absolute'} right={0}></Box>
        <Typography gutterBottom className='fs-52 w-75  fw-bold text-white' data-aos="fade-up">An Independent Technology &
          Innovation Company built for the
          Intelligent Digital Era.</Typography>
        <Box className='d-flex mt-5 pt-4' alignItems={{ md: 'center', lg: "end" }} justifyContent={{ xs: "start", md: "end" }}>
          <RoundTextLogo />
          <Typography className='fs-16  ms-auto text-white' data-aos="fade-up" width={{ xs: "100%", md: "75%", lg: "25%" }}>We shape cohesive digital ecosystems where strategy, design, and technology work in perfect alignment to deliver enduring business value.</Typography>
        </Box>
      </Box>

      <Box className='mt-5'>
        <IndustriesSection />
      </Box>


      <Box className='mt-5'>
        <OurWorks />
      </Box>

      <Box className='mt-3 d-flex justify-content-end'>
        <Box onClick={() => { navigate('/clients') }} className='align-items-center' display={{ xs: "none", md: 'flex' }} order={3}>
          <Typography className='chat-bg fs-18  btn-light-main text-color-main'>Explore more</Typography>
          <Box className='btn-light-main  message-bg' maxHeight={'55px'}><NorthEast sx={{ color: 'var(--primary-dark-color)' }} /></Box>
        </Box>
      </Box>

      <Box className='mt-5'>
        <Typography className='fs-52 text-color-main' data-aos="fade-up" fontWeight={550}>WHAT OUR CLIENTS SAY ABOUT US</Typography>
        <Box className='mt-2'>
          <Carousel />
        </Box>
      </Box>
      {/* <Box className='mt-5'>
        <Typography className='fs-52 mb-4 text-color-main' fontWeight={550}>OUR BLOGS</Typography>
        <Grid container spacing={3}>
          {blogsData?.map((item) => (
            <Grid key={item?.id} size={{ xs: 12, md: 6, lg: 4 }} className='d-flex align-items-start' gap={2}>
              <Box data-aos="fade-up" component={'img'} src={item?.image} width={'150px'} sx={{ objectFit: 'cover', borderRadius: '10px' }} height={'100px'}></Box>
              <Box>
                <Typography data-aos="fade-up" lineHeight={'normal'} className='fs-24 m-0 text-color-main fw-bold'>{item?.title}</Typography>
                <Typography data-aos="fade-up" className='fs-14 text-color'>{item?.description}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

      </Box> */}
      <Box className='mt-5'>
        <LetsTalk />
      </Box>
    </Box>
  )
}

export default HomePage
